<div class="flex flex-col flex-1 md:min-h-0 w-full mx-auto md:overflow-hidden">
  @switch (surveyViewState()) {
    @case ('loading') {
      <div class="flex flex-col flex-1 md:min-h-0 items-center justify-center gap-3 px-5 py-10">
        <p class="!m-0 text-[#6E7A80] text-sm">Loading survey...</p>
      </div>
    }
    @case ('error') {
      <div class="flex flex-col flex-1 md:min-h-0 items-center justify-center gap-5 px-5 py-10">
        <p class="!m-0 text-[#6E7A80] text-sm text-center">{{ loadError() }}</p>
        <button
          type="button"
          class="flex items-center justify-center min-h-[45px] px-[18px] py-[14px] rounded-[12px] border-none bg-[#0f3d3b] text-white text-sm font-medium leading-[17px] cursor-pointer transition-opacity hover:opacity-90"
          (click)="goToDashboard()"
        >
          Close
        </button>
      </div>
    }
    @case ('completed') {
      <div class="flex flex-col flex-1 md:min-h-0 items-center gap-5 w-full max-w-[520px] mx-auto px-5 md:px-8 pt-6 md:pt-8 lg:pt-[52px] pb-6 md:pb-8">
        <div class="flex-1 md:min-h-0 w-px shrink-0"></div>

        <div class="flex items-center justify-center shrink-0 size-20 rounded-full bg-[#ECF6F2]">
          <mat-icon
            svgIcon="pricing-check-mark"
            class="!w-full !h-auto max-w-[38px] max-h-[36px] text-[#50AF95]"
          ></mat-icon>
        </div>

        <h3 class="!m-0 w-full text-[#072935] !text-[26px] !font-semibold leading-[31px] text-center">
          You're all set
        </h3>

        <p class="!m-0 w-full text-[#6E7A80] text-sm leading-[1.5] text-center">
          <span class="font-bold">{{ completedRewardAmount() | cutNumber:('1.2-2') }} USDT</span>
          promo bonus has been credited to your balance. <br> Your AML setup is personalized — let's start verifying wallets.
        </p>

        <div class="flex-1 md:min-h-0 w-px shrink-0"></div>

        <button
          type="button"
          class="flex items-center justify-center w-full gap-1 shrink-0 min-h-[45px] px-[18px] py-[14px] rounded-[12px] border-none bg-[#0f3d3b] text-white text-sm font-medium leading-[17px] cursor-pointer transition-opacity hover:opacity-90"
          (click)="goToDashboard()"
        >
          Go to dashboard →
        </button>
      </div>
    }
    @case ('active') {
    @if (currentQuestion(); as question) {
    @let showError = stepControl | isShowError;
    @let showCustomTextError = customTextControl | isShowError;
    @let iconGrid = showIconGrid();

    <div class="flex flex-col flex-1 md:min-h-0 pt-6 md:pt-8 lg:pt-[52px] md:overflow-hidden">
      <div class="md:flex-1 md:overflow-y-auto md:thin-scroll px-5 md:min-h-[410px]">
        <div class="flex flex-col gap-[6px] shrink-0">
          <h3 class="!m-0 text-[#072935] !text-[17px] !font-semibold leading-[22px]">
            Quick onboarding · Step {{ currentStepNumber() }}
          </h3>

          @if (survey()?.description) {
            <p class="!m-0 min-w-0 break-words text-[#6E7A80] text-[13px] leading-4">{{ survey()?.description }}</p>
          }
        </div>

        <div class="flex gap-[6px] w-full shrink-0 mt-5">
          @for (segmentIndex of progressSegmentIndexes(); track segmentIndex) {
            <div
              class="survey-progress-segment h-[6px] flex-1 min-w-0 rounded-[3px]"
              [class.survey-progress-segment--filled]="segmentIndex < currentStepNumber()"
            ></div>
          }
        </div>

        <div class="flex items-center gap-3 w-full shrink-0 mt-5 min-h-[24px] leading-[1]">
          <p class="!m-0 flex-1 text-[#6E7A80] text-xs font-medium">
            Step {{ currentStepNumber() }} of {{ totalQuestions() }}
          </p>

          @if (currentStepNumber() > 1 && !isReadOnly()) {
            <button
              type="button"
              class="flex items-center min-h-[20px] justify-center gap-[6px] border-none bg-transparent cursor-pointer text-[#072935]"
              (click)="onBack()"
            >
              <span class="text-sm font-medium leading-[1]">←</span>
              <span class="text-[13px] font-medium leading-[1]">Back</span>
            </button>
          }
        </div>

        <div class="flex flex-col flex-1 md:min-h-0 mt-5">
          <div class="flex flex-col">
            <h4 class="!m-0 min-w-0 break-words text-[#072935] !text-[20px] !font-semibold leading-[27px]" style="word-break: break-word;">
              {{ question.question }}
            </h4>
            @if (question.type === 'MULTI_CHOICE') {
              <p class="!m-0 text-[#6E7A80] text-xs leading-[15px] !mt-[20px]">Select all that apply</p>
            }
          </div>

          @if (question.type === 'FREE_TEXT') {
            <div class="flex flex-col gap-1 mt-[10px]">
              <label
                class="relative w-full min-h-[50px] px-[14px] flex items-center bg-white border border-solid border-[#E3E7EA] rounded-[10px] focus-within:border-[#072935]"
                [ngClass]="{ '!border-[#C93535]': showError }"
                [attr.for]="'survey-question-' + question.id"
              >
                <input
                  class="w-full min-w-0 text-[#072935] text-sm leading-[17px] outline-none bg-transparent placeholder:text-[#94A3A6]"
                  type="text"
                  trim="blur"
                  [formControl]="stepControl"
                  [id]="'survey-question-' + question.id"
                  [placeholder]="'Enter your answer here'"
                />
              </label>
            </div>
          } @else if (question.type === 'DROP_DOWN') {
            <div class="flex flex-col gap-1 mt-[10px]">
              <mat-form-field
                class="select-classic survey-select w-full"
                [class.survey-select--error]="showError"
                [class.pointer-events-none]="isReadOnly()"
                subscriptSizing="dynamic"
              >
                <mat-select
                  [formControl]="stepControl"
                  [placeholder]="'Select an option'"
                  [panelClass]="['select-classic-panel', 'survey-select-panel']"
                  (selectionChange)="onSingleChoiceChange()"
                >
                  @for (option of question.options; track option.id) {
                    <mat-option [value]="option.id">{{ option.text }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>

            @if (isCustomTextSelected()) {
              <div #customTextField class="flex flex-col gap-1 mt-[10px]">
                <label
                  class="relative w-full min-h-[50px] px-[14px] flex items-center bg-white border border-solid border-[#E3E7EA] rounded-[10px] focus-within:border-[#072935]"
                  [ngClass]="{ '!border-[#C93535]': showCustomTextError }"
                  [attr.for]="'survey-custom-text-' + question.id"
                >
                  <input
                    class="w-full min-w-0 text-[#072935] text-sm leading-[17px] outline-none bg-transparent placeholder:text-[#94A3A6]"
                    type="text"
                    trim="blur"
                    [formControl]="customTextControl"
                    [id]="'survey-custom-text-' + question.id"
                    placeholder="Enter your answer here"
                  />
                </label>
              </div>
            }
          } @else {
            <div
              class="mt-5"
              [ngClass]="iconGrid ? 'grid grid-cols-2 gap-2' : 'flex flex-col gap-2'"
            >
              @for (option of question.options; track option.id) {
                @let optionIcon = getOptionIconHtml(option);

                <label
                  class="custom-option-card"
                  [class.custom-option-card--tile]="iconGrid"
                  [class.custom-option-card--error]="showError"
                  [class.pointer-events-none]="isReadOnly()"
                  [class.col-span-2]="iconGrid && option.allowsCustomText && !optionIcon"
                >
                  @if (question.type === 'MULTI_CHOICE') {
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      [checked]="isCheckboxOptionSelected(option.id)"
                      (change)="toggleCheckboxOption(option.id)"
                    />
                    @if (!iconGrid) {
                      <span class="custom-checkbox-box">
                        <mat-icon
                          svgIcon="pricing-check-mark"
                          class="custom-checkbox-box__mark"
                        ></mat-icon>
                      </span>
                    }
                  } @else {
                    <input
                      type="radio"
                      class="custom-control-input"
                      [formControl]="stepControl"
                      [value]="option.id"
                      [attr.name]="'survey-question-' + question.id"
                      (change)="onSingleChoiceChange()"
                    />
                    @if (!iconGrid) {
                      <span class="custom-radio-circle">
                        <span class="custom-radio-circle__dot"></span>
                      </span>
                    }
                  }

                  @if (iconGrid) {
                    <span class="custom-option-tile">
                      @if (optionIcon) {
                        <div
                          class="max-w-[120px] max-h-[120px] w-full aspect-square flex flex-col items-center justify-center overflow-hidden"
                        >
                          <div
                            class="w-full h-full [&_svg]:w-full [&_svg]:h-full"
                            [innerHTML]="optionIcon"
                          ></div>
                        </div>
                      }
                      <span class="custom-option-content__title text-center">{{ option.text }}</span>
                    </span>
                  } @else {
                    <span class="custom-option-content">
                      @if (optionIcon) {
                        <div
                          class="max-w-[120px] max-h-[120px] w-full aspect-square flex flex-col items-center justify-center overflow-hidden shrink-0"
                        >
                          <div
                            class="w-full h-full [&_svg]:w-full [&_svg]:h-full"
                            [innerHTML]="optionIcon"
                          ></div>
                        </div>
                      }
                      <span class="custom-option-content__title">{{ option.text }}</span>
                    </span>
                  }
                </label>
              }
            </div>

            @if (isCustomTextSelected()) {
              <div #customTextField class="flex flex-col gap-1 mt-[10px]">
                <label
                  class="relative w-full min-h-[50px] px-[14px] flex items-center bg-white border border-solid border-[#E3E7EA] rounded-[10px] focus-within:border-[#072935]"
                  [ngClass]="{ '!border-[#C93535]': showCustomTextError }"
                  [attr.for]="'survey-custom-text-' + question.id"
                >
                  <input
                    class="w-full min-w-0 text-[#072935] text-sm leading-[17px] outline-none bg-transparent placeholder:text-[#94A3A6]"
                    type="text"
                    trim="blur"
                    [formControl]="customTextControl"
                    [id]="'survey-custom-text-' + question.id"
                    placeholder="Enter your answer here"
                  />
                </label>
              </div>
            }
          }

          @if (showError || showCustomTextError) {
            <app-field-error class="mt-[10px] text-left flex">
              @if (question.type === 'FREE_TEXT' || (isCustomTextSelected() && showCustomTextError)) {
                Please enter your answer to continue
              } @else {
                Please make a selection to continue
              }
            </app-field-error>
          }

          @if (validationError()) {
            <app-field-error class="mt-[10px] text-left flex">
              {{ validationError() }}
            </app-field-error>
          }
        </div>
      </div>

      <div class="survey-footer shrink-0 px-5 pt-[18px] pb-6 md:pb-8">
        <button
          type="button"
          class="w-full flex items-center gap-1 justify-center px-2 min-h-[48px] rounded-[12px] border-none bg-[#0f3d3b] text-white text-base leading-[1] font-medium cursor-pointer transition-opacity hover:opacity-90 disabled:opacity-60 disabled:cursor-not-allowed"
          [disabled]="isSaving() || isReadOnly() || !isStepValid()"
          (click)="isAtEnd() ? onFinish() : onContinue()"
        >
          @if (isSaving()) {
            Saving...
          } @else if (isAtEnd()) {
            Finish
            <mat-icon svgIcon="arrow-right" class="text-white !w-full !h-auto max-w-[16px] max-h-[12px]"></mat-icon>
          } @else {
            Continue
          }
        </button>
      </div>
    </div>
    }
    }
  }
</div>
